export const USER_QUERY_STALE_TIME = 1000 * 60 * 5; // 5 minutos
export const EXTRATO_CREDITO_QUERY_STALE_TIME = 1000 * 60 * 5; // 5 minutos
